import { State } from 'store/main';
import { getItem } from 'utils/localStorage';

export const isStaff = (user: State['currentUser'] | undefined) =>
  user && user.permissions && user.permissions.includes('staff');

export const isLoggedIn = (user?: State['currentUser']): boolean =>
  user !== undefined && user !== null && user.id !== null;

export const isNonAdmin = (user: State['currentUser']) =>
  Boolean(
    user &&
      user.id &&
      user.permissions &&
      !user.permissions.includes('staff') &&
      !user.permissions.includes('orgAdmin')
  );

export const isLocationInCountry = (
  user: State['currentUser'],
  countryCode: string
) => user && user.location && user.location.countryCode === countryCode;

export const isSalarySurveyCompleted = (user: State['currentUser']) => {
  if (user && user.id) {
    return Boolean(user.salarySurvey && user.salarySurvey.lastSubmitted);
  }

  return Boolean(getItem('salarySurveyLastSubmitted'));
};

export const salarySurveyLastSubmittedDate = (user: State['currentUser']) => {
  if (user && user.id) {
    return user.salarySurvey && user.salarySurvey.lastSubmitted;
  }

  const localStorageLastSubmitted = getItem('salarySurveyLastSubmitted');

  if (Array.isArray(localStorageLastSubmitted)) {
    return localStorageLastSubmitted[0];
  }

  return null;
};
